import { Input } from "antd";
import Colors from "assets/Colors";
import EyeIcon from "../../icons/EyeIcon";
import EyeHideIcon from "../../icons/EyeHideIcon";

function CustomInputPassword(props) {
  return (
    <Input.Password
      {...props}
      style={{
        height: "40px",
        width: "100%",
        borderColor: props.valid
          ? Colors.notification_failed
          : Colors.background_dividers,
        borderRadius: "5px",
        borderStyle: "solid",
        ...props.style,
      }}
      iconRender={(visible) =>
        visible ? (
          <span>
            <EyeIcon />
          </span>
        ) : (
          <span>
            <EyeHideIcon />
          </span>
        )
      }
    />
  );
}

export default CustomInputPassword;
